$(function () {

    'use strict';
    let text = document.querySelectorAll('c').forEach(text => {
        text.innerHTML = text.innerText
            .split('')
            .map((letters, i) => {
                if (letters === ' ') {
                    return '<span style="visibility: hidden;">&nbsp;</span>'; // Ajoutez un span caché pour l'espace
                }
                return `<span style="transition-delay:${i * 40}ms;">${letters}</span>`;
            })
            .join('');
    });

    $('.menu__item').on("mouseenter", function () {
        let id = $(this).data('id');
        $('#' + id + '-bg__img').addClass('active');

        // Rétrécir le logo et appliquer un flou
        $('.logo-header').css({
            transform: 'scale(0.5)',
            filter: 'blur(3px)'
        });

		$('.pro__link').css({
            transform: 'scale(0.5)',
            filter: 'blur(2px)'
        });
		$('.socials').css({
            transform: 'scale(0.5)',
            filter: 'blur(2px)'
        });
    });
    $('.menu__item').on("mouseleave", function () {
        $('.menu-img img').removeClass('active');

        // Rétablir la taille normale du logo et supprimer le flou
        $('.logo-header').css({
            transform: 'scale(1)',
            filter: 'none'
        });
		$('.pro__link').css({
            transform: 'scale(1)',
            filter: 'none'
        });

		$('.socials').css({
            transform: 'scale(1)',
            filter: 'none'
        });
    });
})
